export const GENERATED_VOICE_GRID_ID = 'generated-voice-list-grid';
export const GENERATED_VOICE_GRID_ITEM_WIDTH = 300;
export const GENERATED_VOICE_GRID_ITEM_HEIGHT = 64;

export interface GeneratedVoiceListProps {
  isGenerating: boolean;
  enableDragToCanvas?: boolean;
  onAddAudioItem(itemId: string): Promise<void>;
}
